import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS, computed } from 'mobx';
import { observer } from 'mobx-react'


import Slider from 'react-rangeslider';
import { IconTextAdd2, IconArrow, IconFontBold, IconFontUnderline, IconFontCenter, IconFontItalic, IconFontLeft, IconFontRight, IconFontSpace, IconFontSize, IconFill} from './Icons';
import {hexToRGB,HEXtoCMYK} from './ColorTransformFuctions'
import Picker from './Picker';
import Select from 'react-select';
import Tip from './Tip';
import AutosizeInput from 'react-input-autosize';
import BaseText from './BaseText';
import ACEF from './AddCanvasElementFunctions';
import Settings from './Settings';

@observer
export default class ToolbarText extends BaseText{

  @observable trans = {  };
  @observable textButtonHover = false;

  ACEF = new ACEF();

  constructor(props) {

    super(props);
    this.trans = this.props.dictionaryStorage.getCurrentLangDict;
  }

  @computed get currentTextColorRGB() {
    if( this.currentTextColor )
    {
      let rbg = hexToRGB(this.currentTextColor);
      return 'R'+rbg.r+' G'+rbg.g+' B'+rbg.b;
    }
    else{
      return null;
    }
  }

  @computed get currentTextColorCMYK() {
    if( this.currentTextColor )
    {
      let cmyk = HEXtoCMYK(this.currentTextColor);

      return 'C'+cmyk.c+' M'+cmyk.m+' Y'+cmyk.y+' K'+cmyk.k;
    }
    else{
      return null;
    }
  }

  addText(conf){
    this.ACEF.addText(conf);
  }

  render() {

    const t = this.t;
    const currentFontStyle = toJS(this.currentFontStyle);
    let fontSizes = [];
    for ( var i = 0; i < 100; i++ )
    {
      let obj = {
        label : i+'px',
        value : i*10,
      }
      fontSizes.push(obj);
    }

    return (
      <div className="ToolbarText">
        <h6 className="Toolbar-title"><span>{t('Text')}</span></h6>
        <div className="Toolbar-body">

          <div className="ToolbarText-row">
            <span className="ToolbarText-add" >
              <span>{t('Add Text canvas')}</span>
              <span
                onMouseEnter={ ()=> { this.textButtonHover = true } }
                onMouseLeave={ ()=> { this.textButtonHover = false } }
                className="ToolbarText-add-button"
                onClick={()=>{this.addText()}}>
                  <IconTextAdd2 hover={this.textButtonHover} />
                </span>
            </span>
          </div>
          {

            <div>
            <div className={"ToolbarTextText " + ( !Settings.getSettingsIsActiveText ? " disable-area" : "" )}>
                {
                  ( !Settings.getSettingsIsActiveText )
                  &&
                  <div className="UniversalPrevent"></div>
                }

                  <span className="ToolbarText-fontsTitle">{t('Font family')}</span>
                  <div className="font-first">
                    <Select
                      className="Text-select"
                      options={this.fonts}
                      onChange={ (val) => {
                        this.changeFontFamily(val)
                      } }
                      optionRenderer={this.fontRenderOption}
                      valueRenderer={this.renderValue}
                      value={Settings.getSettingsCurrentFont.family}
                      clearable={false}
                      searchable={false}

                    />


              </div>

              <div className="ToolbarText-row ">
                <div className="Text-fontSize">
                <span className="Text-icon">
                  <IconFontSize/>
                </span>
                  <div className="ToolbarText-select-v2">
                    <div className="Text-select-v2-input" onClick={ () => {
                      this.showTipFontSize = true;
                      if ( $(window).width() > 1024 ) this.textNameInput.focus();
                    }}>
                      <AutosizeInput ref={(input) => {
                        this.textNameInput = input;
                      }} value={Settings.getSettingsCurrentFont.size} onChange={(e) => {
                        this.currentFontSizeInputChange(e)
                      }}/>
                      <span>px</span>
                      <IconArrow active={true} size="small"/>
                    </div>
                    {
                      this.showTipFontSize
                      &&
                      <Tip
                        handleClickOutside={ () => {
                          this.showTipFontSize = false;
                        }}
                        style={{width: '140px', padding: '12px 10px'}}>
                        <Slider
                          min={6}
                          max={60}
                          value={Settings.getSettingsCurrentFont.size}
                          onChange={ (val) => {
                            this.changeFontSize(val)
                          } }
                          // onChangeComplete={ ()=> { this.changeFontSize() } }
                        />
                      </Tip>
                    }


                  </div>
                  {
                    false
                    &&
                    <Select
                      className="Text-select"
                      options={fontSizes}
                      value={Settings.getSettingsCurrentFont.size}
                      onChange={ (e) => {
                        this.changeFontSize(e)
                      } }
                      clearable={false}
                      searchable={false}
                    />
                  }

                </div>

                <div className="Text-fontSpace ">
                <span className="Text-icon">
                    <IconFontSpace/>
                </span>

                  <Select
                    className="Text-select"
                    options={fontSizes}
                    value={Settings.getSettingsCurrentFont.space}
                    onChange={ (e) => {
                      this.changeFontSpace(e)
                    } }
                    clearable={false}
                    searchable={false}
                  />

                </div>

              </div>
              <div className="ToolbarText-row ToolbarTextIcons">
                <div className="ToolbarText-fontStyle">
                  <div
                    style={ {fontWeight: 'bold'} }
                    onClick={ () => {
                      this.setFontStyle('fontWeight')
                    } }
                    className={ ( Settings.getSettingsCurrentFont.style.fontWeight == 'bold' ) ? 'active ' : '' }
                  ><IconFontBold/></div>
                  <div
                    style={ {fontStyle: 'italic'} }
                    onClick={  () => {
                      this.setFontStyle('fontStyle')
                    } }
                    className={ ( Settings.getSettingsCurrentFont.style.fontStyle == 'italic' ) ? 'active ' : '' }
                  ><IconFontItalic/></div>
                  <div
                    style={ {textDecoration: 'underline'} }
                    onClick={  () => {
                      this.setFontStyle('textDecoration')
                    } }
                    className={ ( Settings.getSettingsCurrentFont.style.textDecoration == 'underline' ) ? 'active ' : '' }
                  ><IconFontUnderline/></div>


                  <div
                    onClick={ () => {
                      this.setFontStyle('textAlign', 'left')
                    } }
                    className={ ( Settings.getSettingsCurrentFont.style.textAlign == 'left' ) ? 'active ' : '' }
                  >
                    <IconFontLeft/>

                  </div>
                  <div
                    onClick={ () => {
                      this.setFontStyle('textAlign', 'center')
                    } }
                    className={ ( Settings.getSettingsCurrentFont.style.textAlign == 'center' ) ? 'active ' : '' }
                  >
                    <IconFontCenter/>

                  </div>
                  <div
                    onClick={ () => {
                      this.setFontStyle('textAlign', 'right')
                    } }
                    className={ ( Settings.getSettingsCurrentFont.style.textAlign == 'right' ) ? 'active ' : '' }
                  >
                    <IconFontRight/>

                  </div>

                </div>


              </div>

              <div className="ToolbarText-picker">
                <span className="ToolbarText-color" onClick={ () => {
                  this.showTextPicker = !this.showTextPicker;
                }}>
                  <span className="ToolbarText-icon">
                    <IconFill size="medium"/>
                  </span>
                  <span className="ToolbarText-color-box" style={{backgroundColor: Settings.getSettingsCurrentFont.color}}></span>
                </span>
                <div className="ToolbarText-picker-info">
                  <span>{Settings.getSettingsCurrentFont.color || '#fff'}</span>
                  <span>{this.currentTextColorRGB || 'R255 G255 B255'} </span>
                  <span>{this.currentTextColorCMYK || 'C10 M0 Y0 K0'}</span>
                </div>

              </div>


            </div>

            {
              this.showTextPicker
              &&
              <Picker
              //currentColor={this.currentTextColor} // todo: add this option
              dictionaryStorage={this.props.dictionaryStorage}
              onChoiceColor={  (color) => {
              this.onChoiceColor(color)
            } }
              onClickOutside={ () => {
              this.toggleTextColorPicker()
            } }
              >
              </Picker>
            }
            </div>

          }

        </div>




      </div>
    );

  }
}


